




















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Event from '@/utils/event';
import { hasPermission } from '@/utils/utils';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: { ...mapGetters(['userInfo'])}
})
class DATALIST extends Vue {
  userInfo: any;
  collapsed: boolean = true;
  basePath: any[] = [];
  menuList: any[] = [
    {
      name: '数据报表查询',
      path: '/data/formList',
      iconType: 'bar-chart',
      show: false,
      permissionPath: '/data/formList'
    }
  ];

  @Watch('$route.path')
  routeChange(value) {
    if (value === '/data') {
      this.initMenu();
      this.initRoute();
    } else {
      this.setMenuOpenKey();
    }
  }

  created() {
    this.initMenu();
    this.initRoute();
    Event.$on('setPermission', this.initMenu);
  }

  beforeDestroy() {
    Event.$off('setPermission', this.initMenu);
  }

  handleClick(e) {
    this.$router.push(e.key);
  }

  initMenu() {
    const { permissions:queue } = this.userInfo || {};
    this.menuList.forEach(_ => (_.show = hasPermission(queue, _.permissionPath)));
  }

  initRoute() {
    let defaultMenu = this.menuList.find(_ => _.show);
    let path = this.$route.path;
    console.log(path);
    if (defaultMenu && /^\/data\/?$/.test(path)) {
      this.$router.push(defaultMenu.path);
      path = defaultMenu.path;
    }
    this.basePath[0] = path;
  }

  setMenuOpenKey() {
    let current = this.menuList.find(v => v.path === this.$route.path);
    if (current) {
      if (!this.collapsed) {
        this.basePath = [current.path];
      }
    }
  }
}

export default DATALIST;
